import React, {ReactElement} from "react";
import {useAppSelector} from "lib/redux/hooks";
import { menuEditorSelectors } from "features/editor/editorSlice";
import { CoverPagePreview } from "features/editor/preview/CoverPagePreview";
import { EditorItem } from "features/editor/editorUtils";
import { AperitifItem, ImageItem, isAperitifItem, isImageItem, isMarginItem, isPageBreakItem, isPageTitleItem, isTitleItem, isWineItem, MarginItem, MenuItem, PageTitleItem, TitleItem, WineItem } from "features/editor/MenuDocumentModel";
import { PageTitlePreviewItem } from "features/editor/preview/PageTitlePreviewItem";
import { TitlePreviewItem } from "features/editor/preview/TitlePreviewItem";
import { MarginPreviewItem } from "features/editor/preview/MarginPreviewItem";
import { ImagePreviewItem } from "features/editor/preview/ImagePreviewItem";
import { WinePreviewItem } from "features/editor/preview/WinePreviewItem";
import { Footer } from "features/editor/preview/Footer";
import { LabelPreviewItem } from "features/label-editor/LabelPreviewItem";
import { isLabelItem, LabelItem } from "features/label-editor/LabelDocumentModel";
import { createDocumentHandler } from "features/editor/documentHandlerUtils";
import { AperitifPreviewItem } from "features/aperitif/AperitifPreviewItem";


export interface PDFProps {

}

export function PDF(props: PDFProps): ReactElement | null {
    const document = useAppSelector(menuEditorSelectors.document);
    if (document == null) {
        return null;
    }
    const docHandler = createDocumentHandler(document);
    const pageStyling = docHandler.getPageStyling("pdf");

    return (
        <>
            {document.coverPage && <CoverPagePreview />}

            {document.pages.map((page, pageIndex) => (
                <div key={pageIndex} className={`bg-white flex flex-col relative
                     ${pageStyling.className}`}
                     style={{pageBreakAfter: 'always', ...pageStyling.style}}
                >
                    {page.map((item, itemIndex) => (
                        <div key={itemIndex} className="relative bg-white">
                            <PreviewComponent
                                item={{
                                    itemKey: {
                                        page: pageIndex,
                                        item: itemIndex
                                    },
                                    menuItem: item
                                }}
                                format={document.format}
                                degu={document.degu}
                            />
                        </div>
                    ))}

                    {document.displayFooter && <Footer degu={document.degu} />}
                </div>
            ))}
        </>
    );
}

export type MenuFormat = 'a4' | 'a4-half' | 'a5' | 'a6' | 'custom';

interface PreviewComponentProps {
    item: EditorItem<MenuItem>
    format: MenuFormat
    degu?: boolean
}

function PreviewComponent(props: PreviewComponentProps): ReactElement | null {
    if (isPageTitleItem(props.item.menuItem)) {
        return <PageTitlePreviewItem format={props.format} title={props.item as EditorItem<PageTitleItem>}/>
    }
    if (isTitleItem(props.item.menuItem)) {
        return <TitlePreviewItem format={props.format} degu={props.degu || false} title={props.item as EditorItem<TitleItem>}/>
    }
    if (isMarginItem(props.item.menuItem)) {
        return <MarginPreviewItem showBorders={false} format={props.format} margin={props.item as EditorItem<MarginItem>}/>
    }
    if (isPageBreakItem(props.item.menuItem)) {
        return <></>;
        // return <PageBreakPreviewItem format={props.format} pageBreak={props.item as EditorItem<PageBreakItem>}/>
    }
    if (isImageItem(props.item.menuItem)) {
        return <ImagePreviewItem format={props.format} image={props.item as EditorItem<ImageItem>}/>
    }
    if (isWineItem(props.item.menuItem)) {
        return <WinePreviewItem format={props.format} degu={props.degu || false} wineItem={props.item as EditorItem<WineItem>}/>
    }
    if (isLabelItem(props.item.menuItem)) {
        return (
            <LabelPreviewItem 
                labelItem={props.item as EditorItem<LabelItem>}
            />
        )
    }
    if (isAperitifItem(props.item.menuItem)) {
        return (
            <AperitifPreviewItem
                aperitifItem={props.item as EditorItem<AperitifItem>}
                format={props.format}
            />
        )
    }

    return null;
}
